import { render, staticRenderFns } from "./SplitsTable.vue?vue&type=template&id=5367f376&scoped=true&"
import script from "./SplitsTable.vue?vue&type=script&lang=js&"
export * from "./SplitsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5367f376",
  null
  
)

export default component.exports